const { kill } = require("process");
window.console.log("kill", kill);
// const { exec } = require("child_process");

class NoiseCancel {
	constructor(input_filename, callback_progress_bar, callback_on_close) {
		this.debug_msg_flag = false;
		const python_main_py = "./run_main_noise_cancel.py";
		const argument_string = `--input_filename=${input_filename}`;

		const arg_array = this.make_arg_array(python_main_py, argument_string);
		var output_filename = "";
		let { cp } = require("child_process");
		window.console.log("cp", cp);
		// const cp = require("child_process");
		// const spawn = cp.spawn("cmd");
		this.child = cp.spawn("python3", arg_array, { stdio: "pipe" });

		this.child.stdout.on("data", data => {
			if (this.debug_msg_flag) {
				window.console.log("stdout: " + data);
			}
		});

		this.child.stderr.on("data", data => {
			if (data.slice(0, 7) == "percent") {
				//data가 'percent100' 이라면 100% 진행한 것임.
				var percent = Number(data.slice(7, 10));
				if (!isNaN(percent)) {
					callback_progress_bar(percent);
				}
			} else if (data.slice(0, 8) == "outpath=") {
				output_filename = data.slice(8, data.length);
			} else {
				if (this.debug_msg_flag) {
					window.console.log("callback print: " + data);
				}
			}
		});

		this.child.on("close", code => {
			if (this.debug_msg_flag) {
				window.console.log(`exit code=${code}`);
			}
			callback_on_close(code, output_filename);
		});
	}

	kill() {
		this.child.kill();
	}

	debug_message_flag(flag) {
		this.debug_msg_flag = flag;
	}

	make_arg_array(python_main_py, argument_string) {
		argument_string = argument_string.split(" ");
		argument_string.unshift(python_main_py);
		return argument_string;
	}
	/*
												  send_message(msg) {
													  window.console.log("sending to python: "+msg);
													  this.child.stdin.write(msg+"\n");
												  }
												  */
}

module.exports = NoiseCancel;
